module.exports = __webpack_public_path__ + "static/media/KOM_05.ce922317.png";